import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { filter } from 'rxjs/operators';

import { DialogConfirmComponent } from '@app/shared/components/confirm-delete.component';

import { IParceiro, IParceiroContato } from '../../model/parceiro.model';
import { DialogNovoContatoComponent } from '../dialog-novo-contato/dialog-novo-contato.component';

@Component({
  selector: 'parceiro-form-contact',
  templateUrl: './form-contact.component.html',
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0, height: 0 }),
        animate('0.2s', style({ opacity: 1, height: '*' }))
      ]),
      transition(':leave', [
        style({ height: '*' }),
        animate('0.2s', style({ opacity: 0, height: 0 }))
      ])
    ])
  ]
})
export class ContactFormComponent {
  // mensagens de erros
  public displayMessage = {};

  @Input() entity: IParceiro;

  @Input() readonly = false;

  blocked_actions = false;

  entityTemp: IParceiro;

  // eslint-disable-next-line no-useless-constructor
  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected snack: MatSnackBar,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.entityTemp = this.entity;

    if (!this.entityTemp.contatos) this.entityTemp.contatos = [];
    else
      this.entityTemp.contatos.forEach(contato => {
        if (typeof contato.tag === 'string')
          contato.tag = contato.tag.split(' ');
      });

    this.blocked_actions =
      localStorage.getItem('INTEGRACAO') === 'true' ? true : false;
  }

  addContato(): void {
    const observer = this.dialog
      .open(DialogNovoContatoComponent, {
        panelClass: ['transparent-dialog'],
        data: {
          contato: {
            contato: '',
            tag: ''
          }
        }
      })
      .afterClosed();
    observer
      .pipe(filter(result => !!result))
      .subscribe((result: IParceiroContato) => {
        if (result) this.entityTemp.contatos.push(result);
      });
  }

  editarContato(contato: IParceiroContato, index: number): void {
    if (!contato && index < 0) return;

    const observer = this.dialog
      .open(DialogNovoContatoComponent, {
        width: '400px',
        data: {
          contato
        }
      })
      .afterClosed();

    observer
      .pipe(filter(resposta => !!resposta))
      .subscribe((respostaContato?: IParceiroContato) => {
        this.entityTemp.contatos[index] = respostaContato;
      });
  }

  getValues(): IParceiroContato[] {
    if (!this.entityTemp.contatos.length) return [];
    return this.entityTemp.contatos.map(
      (contato): IParceiroContato => ({
        ...contato,
        tag:
          typeof contato.tag === 'string' ? contato.tag : contato.tag.join(' ')
      })
    );
  }

  public updateValues(parceiro: IParceiro): void {
    if (!parceiro.contatos) {
      this.entityTemp.contatos = [];
      return;
    }
    this.entityTemp = parceiro;
  }

  /**
   * Formata uma tag para ser mostrada na view
   * @param tag tag a ser formatada
   */
  formatarTags(tag: string[]): string[] {
    if (typeof tag === 'object') return tag.filter(tg => tg !== '');
    else return tag;
  }

  removerContato(event: MouseEvent, contato: IParceiroContato): void {
    event.stopPropagation();
    const index = this.entityTemp.contatos.findIndex(
      contatoExistente =>
        contatoExistente.id === contato.id &&
        contatoExistente.contato === contato.contato
    );

    if (index >= 0) {
      const observer = this.dialog
        .open(DialogConfirmComponent, {
          data: {
            titulo: 'Excluir Contato',
            msg: `Deseja excluir a(o) Contato ${this.entityTemp.contatos[index].contato}`
          }
        })
        .afterClosed();
      observer.pipe(filter(resposta => resposta)).subscribe((): void => {
        this.entityTemp.contatos.splice(index, 1);
      });
    }
  }
}
